//按需加载
import {
  //addTransform,
  //editTransform,
  deleteTransform,
} from "../../../../api/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      bimEngineeringChangeCategory_show: true,
      bimEngineeringChangeCategory_submit_disabled: false,

      form: {
        id: "",
        parentId: "",
        name: "",
        transformType: "",
      },

      title: "新增",
      rules: {
        parentId: [
          {
            required: true,
            message: "请选择所属分类",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur",
          },
        ],
      },
      isEdit: false,
      data: {},

      //请求后端变更项分类树时，记得在顶部添加一项，{value: '0',label: '根目录'},保障下拉框至少有一项，且可以新建目录树。
      options: [],
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          /* 表单提交后3秒内不可重复点击 */
          this.bimEngineeringChangeCategory_submit_disabled = true;
          let that = this;
          //console.log(this);
          setTimeout(function() {
            that.bimEngineeringChangeCategory_submit_disabled = false;
          }, 3000);

          const formData = JSON.parse(JSON.stringify(this.form));
          // console.log(formData);
          formData.transformType = "directory"; //指明添加的数据为文件类型。
          // console.log(formData);
          if (this.isEdit) {
            //axios请求编辑数据。

            let mdeData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              pid: this.form.parentId,
              name: this.form.name,
              transformType: "content", //数据库里transformtype为content表示是目录，但是前端程序里transformType为directory表示是目录。
              id: this.form.id,
              owner: true, //默认共享目录。
            };
            editTransform(mdeData).then((res) => {
              //console.log(JSON.parse(JSON.stringify(res)));
              //console.log(3333333333333333333);
              if (res.data.success && res.data.code === 204) {
                //表单验证设置了下拉框必选，需要将未选择下拉框和选择根目录区分开，而目录树里的根目录parentId是'',不是'0'。数据库里parentId为0表示上级是根目录。
                // // 本地更新目录树
                // if (formData.parentId === '0') {
                // 	formData.parentId = '';
                // }
                // this.$emit('edit_bimEngineeringChangeCategory', formData);

                // 改为：直接通知父组件刷新数据
                that.$parent.initTreeData();

                that.$notify({
                  title: "已成功更新变更项分类。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert(
                  "修改变更项分类保存失败了，请再试一次吧~",
                  "编辑失败",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            });
          } else {
            //axios请求新增数据。
            let mdaData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              pid: this.form.parentId,
              name: this.form.name,
              transformType: "content", //数据库里transformtype为content表示是目录，但是前端程序里transformType为directory表示是目录。
              owner: true, //默认共享目录。
            };
            addTransform(mdaData).then((res) => {
              //console.log(JSON.parse(JSON.stringify(res)));
              //console.log(3333333333333333333);
              if (res.data.success && res.data.code === 204) {
                //表单验证设置了下拉框必选，需要将未选择下拉框和选择根目录区分开，而目录树里的根目录parentId是'',不是'0'。数据库里parentId为0表示上级是根目录。
                // // 本地更新目录树
                // if (formData.parentId === '0') {
                // 	formData.parentId = '';
                // }
                // // 随机生成id(仅为前端模拟使用，正常场景应为后台数据库新增记录成功后返回的主键Id)
                // formData.id = Math.random();
                // //新增目录树数据
                // this.$emit('add_bimEngineeringChangeCategory', formData);

                // 改为：直接通知父组件刷新数据
                that.$parent.initTreeData();

                that.$notify({
                  title: "已成功新增变更项分类。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("添加变更项分类失败了，请再试一次吧~", "添加失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          }
          this.bimEngineeringChangeCategory_click();
        }
      });
    },

    addDirectory(fdata) {
      //fdata为目录选项数据。
      if (fdata == undefined || fdata.length <= 0) {
        fdata = [];
      }
      this.isEdit = false;
      this.title = "新增";
      this.initFormData();
      this.$refs.form.resetFields();
      fdata.unshift({
        name: "根分类",
        parentId: "-1",
        id: "0",
        transformType: "directory",
      });
      this.options = fdata;
    },
    editDirectory(data, fdata) {
      //data为编辑数据，fdata为目录选项数据。
      if (fdata == undefined || fdata.length <= 0) {
        fdata = [];
      }
      fdata.unshift({
        name: "根分类",
        parentId: "-1",
        id: "0",
        transformType: "directory",
      });

      if (!data.parentId) {
        data.parentId = "0";
      }
      this.options = fdata;
      this.form = data;
      this.data = data; //这个this.data是方便页面里的删除按钮传值的。
      this.isEdit = true;
      this.title = "编辑";
    },
    initFormData() {
      this.form = {
        parentId: "",
        name: "",
      };
    },
    deleteDirectory() {
      if (this.data && this.data.id) {
        this.$parent.deleteTreeItem(this.data);
      } else {
        this.$alert("删除失败，因为发生了数据错误", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    bimEngineeringChangeCategory_click() {
      this.$refs.form.resetFields();
      this.$emit("bimEngineeringChangeCategory_close");
    },
  },
  watch: {},
};
